// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance-pivot-report-container {
    width: 100%;
   max-height: 360px;
    overflow-x: auto; /* Enables horizontal scrolling for wide tables */
    margin-top: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    position: relative;
}

.attendance-pivot-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.8em;
    min-width: 800px; /* Ensure a minimum width to enable scrolling */
}

.attendance-pivot-table thead th {
    background-color: #e4f0e4;
        padding: 8px 8px;
    text-align: center;
    border: 1px solid #ddd;
    white-space: nowrap; /* Keep headers on one line */
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 40;
}

/* .fixed-column-header 
.fixed-column-cell{
    background-color: #e0e0e0; 
    position: sticky;
   
    z-index: 10; 
} */
 .fixed-column-header,
.fixed-column-cell {
    position: sticky;
    background-color: #f9f9f9;
    z-index: 50;
    border-right: 1px solid #ddd;
    top:0;
}
.fixed-column-header{
top:0 !important;
position: sticky !important;
z-index: 60 !important;
}

.date-group-header {
    background-color: #b3e0ff; /* Light blue for date group headers */
    color: #333;
    position:sticky;
    z-index: 80;
    top: 0;
}

.date-header-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.85em;
    position : sticky;
    z-index: 80;
    top: 0;
} 

.day-name {
    font-weight: normal;
    font-size: 0.8em;
    margin-top: 2px;
}

.punch-header {
    background-color: #d9edf7; /* Lighter blue for In/Out headers */
    font-weight: normal;
    font-size: 0.8em;
    padding: 6px 4px;
    border-top: 1px solid #ddd;
    top:45px !important;
    position: sticky !important;
    z-index: 40;
}

.attendance-pivot-table tbody td {
    padding: 8px 5px;
    border: 1px solid #eee;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap; /* Prevent wrapping in cells */
}
.attx-full-cell {
    display: flex;
    flex-direction: column;
}
.att-inout {
    display: flex;
    justify-content: center;
    gap: 6px;
}
.pa-count{
    font-weight: 600;
    font-size: 0.9em;
}

/* .fixed-column-cell {
    background-color: #f9f9f9;
    position: sticky;
    left: 0;
    z-index: 8; 
    border-right: 1px solid #ddd;
    text-align: left;
    padding-left: 10px;
} */

/* Status specific styling */
.attendance-cell.status-absent {
    background-color: #ffe0e0; /* Light red */
    color: #c00;
    font-weight: bold;
}

.attendance-cell.status-present {
    background-color: #e0ffe0; /* Light green */
    color: #0c0;
}

.attendance-cell.status-holiday {
    background-color: #f0e0ff; /* Light purple */
    color: #ad820d;
}

.attendance-cell.status-w-o { /* For Weekend Off */
    background-color: #e6e6e6; /* Grey */
    color: #555;
    font-weight: bold;
}

.attendance-cell.status-missed-punch {
    background-color: #fffacd; /* Lemon Chiffon */
    color: #c08;
    font-weight: bold;
}
   

.editable-status-cell {
  /* Light blue background to indicate editability */
  cursor: pointer;
}


/* In your ComponentsCss/AdminPanel/ReportsComponent/AttendancePivotReport.css */

.update-button-container {
  position: sticky; /* Make it sticky to the bottom of its scrollable parent */
  bottom: 0;
  right: 0;
  width: 100%; /* Or set a fixed width */
  display: flex;
  justify-content: flex-end; /* Align to bottom right */
  padding: 15px;
  background-color: #f0f0f0; /* Light background to make it stand out */
  border-top: 1px solid #ddd;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
  z-index: 1000; /* Ensure it's above other content */
}

.update-attendance-btn {
  padding: 12px 25px;
  font-size: 16px;
  background-color: #007bff; /* Primary blue */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.update-attendance-btn:hover {
  background-color: #0056b3;
}

.update-attendance-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}



.attendance-pivot-table th.fixed-column-header:nth-child(1),
.attendance-pivot-table td.fixed-column-cell:nth-child(1) {
  left: 0;
  z-index: 50;
    
}

.attendance-pivot-table th.fixed-column-header:nth-child(2),
.attendance-pivot-table td.fixed-column-cell:nth-child(2) {
  left: 78px;
  z-index: 50;
   
}

.attendance-pivot-table th.fixed-column-header:nth-child(3),
.attendance-pivot-table td.fixed-column-cell:nth-child(3) {
  left: 193px;
  z-index: 50;
    
}

.attendance-pivot-table th.fixed-column-header:nth-child(4),
.attendance-pivot-table td.fixed-column-cell:nth-child(4) {
  left: 292px;
  z-index: 50;
} 

.present-absent-cell {
    
    font-weight: 600;
}
.pa-cell{
  padding-bottom: 1px;
}
.present-cell {
    color: green;
}
.absent-cell {
    color: red;
}
.combined-punch-cell {
  position: relative;
  cursor: pointer;
}

.attx-full-cell {
  position: relative;
}

/* Tooltip hidden by default */
.attx-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
}

/* Arrow */
.attx-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

/* Show tooltip on hover */
.combined-punch-cell:hover .attx-tooltip {
  opacity: 1;
}

.attendance_bottom_user_pagin{
    margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/AttendancePivotReport.css"],"names":[],"mappings":"AAAA;IACI,WAAW;GACZ,iBAAiB;IAChB,gBAAgB,EAAE,iDAAiD;IACnE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA;IACI,yBAAyB;QACrB,gBAAgB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB,EAAE,6BAA6B;IAClD,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;;;;;;GAMG;CACF;;IAEG,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,KAAK;AACT;AACA;AACA,gBAAgB;AAChB,2BAA2B;AAC3B,sBAAsB;AACtB;;AAEA;IACI,yBAAyB,EAAE,sCAAsC;IACjE,WAAW;IACX,eAAe;IACf,WAAW;IACX,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB,EAAE,oCAAoC;IAC/D,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB,EAAE,8BAA8B;AACvD;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;;;;;GAQG;;AAEH,4BAA4B;AAC5B;IACI,yBAAyB,EAAE,cAAc;IACzC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,cAAc;AAClB;;AAEA,8BAA8B,oBAAoB;IAC9C,yBAAyB,EAAE,SAAS;IACpC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,kBAAkB;IAC7C,WAAW;IACX,iBAAiB;AACrB;;;AAGA;EACE,kDAAkD;EAClD,eAAe;AACjB;;;AAGA,gFAAgF;;AAEhF;EACE,gBAAgB,EAAE,0DAA0D;EAC5E,SAAS;EACT,QAAQ;EACR,WAAW,EAAE,yBAAyB;EACtC,aAAa;EACb,yBAAyB,EAAE,0BAA0B;EACrD,aAAa;EACb,yBAAyB,EAAE,0CAA0C;EACrE,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;;AAIA;;EAEE,OAAO;EACP,WAAW;;AAEb;;AAEA;;EAEE,UAAU;EACV,WAAW;;AAEb;;AAEA;;EAEE,WAAW;EACX,WAAW;;AAEb;;AAEA;;EAEE,WAAW;EACX,WAAW;AACb;;AAEA;;IAEI,gBAAgB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".attendance-pivot-report-container {\n    width: 100%;\n   max-height: 360px;\n    overflow-x: auto; /* Enables horizontal scrolling for wide tables */\n    margin-top: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    position: relative;\n}\n\n.attendance-pivot-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 0.8em;\n    min-width: 800px; /* Ensure a minimum width to enable scrolling */\n}\n\n.attendance-pivot-table thead th {\n    background-color: #e4f0e4;\n        padding: 8px 8px;\n    text-align: center;\n    border: 1px solid #ddd;\n    white-space: nowrap; /* Keep headers on one line */\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n    z-index: 40;\n}\n\n/* .fixed-column-header \n.fixed-column-cell{\n    background-color: #e0e0e0; \n    position: sticky;\n   \n    z-index: 10; \n} */\n .fixed-column-header,\n.fixed-column-cell {\n    position: sticky;\n    background-color: #f9f9f9;\n    z-index: 50;\n    border-right: 1px solid #ddd;\n    top:0;\n}\n.fixed-column-header{\ntop:0 !important;\nposition: sticky !important;\nz-index: 60 !important;\n}\n\n.date-group-header {\n    background-color: #b3e0ff; /* Light blue for date group headers */\n    color: #333;\n    position:sticky;\n    z-index: 80;\n    top: 0;\n}\n\n.date-header-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 0.85em;\n    position : sticky;\n    z-index: 80;\n    top: 0;\n} \n\n.day-name {\n    font-weight: normal;\n    font-size: 0.8em;\n    margin-top: 2px;\n}\n\n.punch-header {\n    background-color: #d9edf7; /* Lighter blue for In/Out headers */\n    font-weight: normal;\n    font-size: 0.8em;\n    padding: 6px 4px;\n    border-top: 1px solid #ddd;\n    top:45px !important;\n    position: sticky !important;\n    z-index: 40;\n}\n\n.attendance-pivot-table tbody td {\n    padding: 8px 5px;\n    border: 1px solid #eee;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap; /* Prevent wrapping in cells */\n}\n.attx-full-cell {\n    display: flex;\n    flex-direction: column;\n}\n.att-inout {\n    display: flex;\n    justify-content: center;\n    gap: 6px;\n}\n.pa-count{\n    font-weight: 600;\n    font-size: 0.9em;\n}\n\n/* .fixed-column-cell {\n    background-color: #f9f9f9;\n    position: sticky;\n    left: 0;\n    z-index: 8; \n    border-right: 1px solid #ddd;\n    text-align: left;\n    padding-left: 10px;\n} */\n\n/* Status specific styling */\n.attendance-cell.status-absent {\n    background-color: #ffe0e0; /* Light red */\n    color: #c00;\n    font-weight: bold;\n}\n\n.attendance-cell.status-present {\n    background-color: #e0ffe0; /* Light green */\n    color: #0c0;\n}\n\n.attendance-cell.status-holiday {\n    background-color: #f0e0ff; /* Light purple */\n    color: #ad820d;\n}\n\n.attendance-cell.status-w-o { /* For Weekend Off */\n    background-color: #e6e6e6; /* Grey */\n    color: #555;\n    font-weight: bold;\n}\n\n.attendance-cell.status-missed-punch {\n    background-color: #fffacd; /* Lemon Chiffon */\n    color: #c08;\n    font-weight: bold;\n}\n   \n\n.editable-status-cell {\n  /* Light blue background to indicate editability */\n  cursor: pointer;\n}\n\n\n/* In your ComponentsCss/AdminPanel/ReportsComponent/AttendancePivotReport.css */\n\n.update-button-container {\n  position: sticky; /* Make it sticky to the bottom of its scrollable parent */\n  bottom: 0;\n  right: 0;\n  width: 100%; /* Or set a fixed width */\n  display: flex;\n  justify-content: flex-end; /* Align to bottom right */\n  padding: 15px;\n  background-color: #f0f0f0; /* Light background to make it stand out */\n  border-top: 1px solid #ddd;\n  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);\n  z-index: 1000; /* Ensure it's above other content */\n}\n\n.update-attendance-btn {\n  padding: 12px 25px;\n  font-size: 16px;\n  background-color: #007bff; /* Primary blue */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.update-attendance-btn:hover {\n  background-color: #0056b3;\n}\n\n.update-attendance-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n\n\n.attendance-pivot-table th.fixed-column-header:nth-child(1),\n.attendance-pivot-table td.fixed-column-cell:nth-child(1) {\n  left: 0;\n  z-index: 50;\n    \n}\n\n.attendance-pivot-table th.fixed-column-header:nth-child(2),\n.attendance-pivot-table td.fixed-column-cell:nth-child(2) {\n  left: 78px;\n  z-index: 50;\n   \n}\n\n.attendance-pivot-table th.fixed-column-header:nth-child(3),\n.attendance-pivot-table td.fixed-column-cell:nth-child(3) {\n  left: 193px;\n  z-index: 50;\n    \n}\n\n.attendance-pivot-table th.fixed-column-header:nth-child(4),\n.attendance-pivot-table td.fixed-column-cell:nth-child(4) {\n  left: 292px;\n  z-index: 50;\n} \n\n.present-absent-cell {\n    \n    font-weight: 600;\n}\n.pa-cell{\n  padding-bottom: 1px;\n}\n.present-cell {\n    color: green;\n}\n.absent-cell {\n    color: red;\n}\n.combined-punch-cell {\n  position: relative;\n  cursor: pointer;\n}\n\n.attx-full-cell {\n  position: relative;\n}\n\n/* Tooltip hidden by default */\n.attx-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #333;\n  color: #fff;\n  font-size: 12px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  z-index: 1000;\n}\n\n/* Arrow */\n.attx-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent;\n}\n\n/* Show tooltip on hover */\n.combined-punch-cell:hover .attx-tooltip {\n  opacity: 1;\n}\n\n.attendance_bottom_user_pagin{\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
